module.exports = __webpack_public_path__ + "img/frequent-reader.d88c8e99.svg";